import * as PopoverPrimitive from '@radix-ui/react-popover'
import { cx } from '../util/cx'
import styles from './Popover.module.css'

interface PopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  trigger: React.ReactNode
  children: React.ReactNode
  align?: 'start' | 'center' | 'end'
  side?: 'top' | 'right' | 'bottom' | 'left'
  className?: string
}

export default function Popover({
  open,
  onOpenChange,
  trigger,
  children,
  align = 'center',
  side = 'top',
  className,
}: PopoverProps) {
  return (
    <PopoverPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <PopoverPrimitive.Trigger asChild>{trigger}</PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          className={cx(styles.content, className)}
          align={align}
          side={side}
          sideOffset={8}
        >
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  )
}

interface PopoverMenuProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  className?: string
}

/** Anchored menu without a trigger — for context menus positioned by parent layout. */
export function PopoverSurface({ open, onClose, children, className }: PopoverMenuProps) {
  if (!open) return null

  return (
    <PopoverPrimitive.Root open onOpenChange={(next) => !next && onClose()}>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          className={cx(styles.content, className)}
          onOpenAutoFocus={(event) => event.preventDefault()}
        >
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  )
}
